import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  HostListener,
} from '@angular/core';
import { Router } from '@angular/router';
import { first, takeUntil } from 'rxjs';
import { SettingsService } from '@api/settings.service';
import { BaseObject } from '@shared/base/base-object';
import { AuthenticationService } from '@shared/authentication/authentication.service';
import { AppState, DeferActionEnum } from '@shared/states/app-state.service';
import { ThemeState } from '@shared/states/theme.state';
import { UserState } from '@shared/states/user.state';
import { BreakpointTypeEnum } from '@shared/types/screen-breakpoints';
import {
  SendStatisticsService,
  StatisticsActionKey,
  StatisticsContextEnum,
} from '@shared/api/send-statistics.service';

/** Порог скролла (px), после которого панель переключается в «плавающую капсулу». */
const SCROLL_COMPACT_THRESHOLD = 8;

@Component({
  selector: 'app-navigation-panel',
  templateUrl: './navigation-panel.component.html',
  styleUrls: ['./navigation-panel.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[class.mobile]': 'settingsService.screenBreakpoint$.value === "XXSmall"',
    '[class.navigation-panel--scrolled]': 'scrolled',
  },
})
export class NavigationPanelComponent extends BaseObject implements AfterViewInit {
  public readonly BreakpointTypeEnum = BreakpointTypeEnum;

  public scrolled = false;

  constructor(
    public themeState: ThemeState,
    private authService: AuthenticationService,
    public settingsService: SettingsService,
    public userState: UserState,
    private router: Router,
    private cdr: ChangeDetectorRef,
    private appState: AppState,
    private statistics: SendStatisticsService,
  ) {
    super();
  }

  public ngAfterViewInit(): void {
    this.syncScrolledFromScrollPosition();
  }

  @HostListener('window:scroll')
  public onWindowScroll(): void {
    this.syncScrolledFromScrollPosition();
  }

  private syncScrolledFromScrollPosition(): void {
    const y = window.scrollY ?? document.documentElement.scrollTop ?? 0;
    const next = y > SCROLL_COMPACT_THRESHOLD;
    if (next !== this.scrolled) {
      this.scrolled = next;
      this.cdr.markForCheck();
    }
  }

  public onLogoClick(): void {
    this.router.navigate(['/']);
  }

  public toLogin(): void {
    this.appState.deferActions$.next([{ type: DeferActionEnum.Routing, url: location.pathname }]);
    this.router.navigate(['/login']);
  }

  public logout(): void {
    this.authService
      .logout()
      .pipe(first(), takeUntil(this.destroy$))
      .subscribe(() => location.replace('login'));
  }

  public toConfigurator(): void {
    this.statistics
      .sendStat(StatisticsActionKey.ESTIMATE_MAIN_4, StatisticsContextEnum.LANDING)
      .subscribe(() => window.location.replace('https://remont.ugol.me'));
  }
}
